import { render, staticRenderFns } from "./_paymentUuid.vue?vue&type=template&id=b72519ba"
import script from "./_paymentUuid.vue?vue&type=script&lang=js"
export * from "./_paymentUuid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports